import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import ChatWidget from './ChatWidget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-solid-svg-icons';

function initializeChatWidget(config) {
  const existingContainer = document.getElementById('live-chat-widget-root');
  if (existingContainer) {
    console.warn('Chat widget is already initialized.');
    return;
  }


  const container = document.createElement('div');
  container.id = 'live-chat-widget-root';
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);

  const ChatWidgetWrapper = () => {
    const [isOpen, setIsOpen] = useState(config?.autoOpen || false);
    const [showWidget, setShowWidget] = useState(config?.autoOpen || false);
    const [
      screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
      if (isOpen) {
        setShowWidget(true);
      }
    }, [isOpen]);

    const toggleChat = () => {
      if (isOpen) {
        // Animate out before hiding
        const widget = document.querySelector('.chat-widget-animate');
        if (widget) {
          widget.classList.remove('slide-in');
          widget.classList.add('slide-out');

          setTimeout(() => {
            setShowWidget(false);
            setIsOpen(false);
          }, 400); // Match animation duration
        }
      } else {
        setIsOpen(true);
      }
    };

    const iconStyles = {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      width: screenWidth <= 1000 ? '150px' : '50px',
      height: screenWidth <= 1000 ? '150px' : '50px',
      borderRadius: '50%',
      backgroundColor: config?.iconBackgroundColor || '#007bff',
      color: config?.iconColor || '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      zIndex: config?.zIndex || 9999,
    };

    let widgetContainerStyle = {
      position: 'fixed',
      bottom: '50px',
      right: '20px',
      zIndex: config?.zIndex || 9999,
    };
    if (screenWidth <= 1000) {
      widgetContainerStyle = {
        ...widgetContainerStyle,
        position: 'fixed',
        fontSize: '45px',
        width: '100%',
        height: '100%',
        bottom: 0,
        right: 0,
      }
    }

    return (
      <>
        <style>{`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(50px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes slideOut {
            from {
              opacity: 1;
              transform: translateY(0);
            }
            to {
              opacity: 0;
              transform: translateY(50px);
            }
          }

          .slide-in {
            animation: slideIn 0.4s ease-out forwards;
          }

          .slide-out {
            animation: slideOut 0.4s ease-in forwards;
          }
        `}</style>

        <div style={iconStyles} onClick={toggleChat}><FontAwesomeIcon icon={faComment} style={{ fontSize: screenWidth <= 1000 ? '70px' : '19px', color: '#fff' }} /></div>

        {showWidget && (
          <div style={widgetContainerStyle} className={isOpen ? 'slide-in chat-widget-animate' : 'slide-out'}>
            <ChatWidget config={config} className="chat-widget-body" onClose={toggleChat} />
          </div>
        )}
      </>
    );
  };

  root.render(<ChatWidgetWrapper />);
}

window.LiveChatWidget = {
  init: (config) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeChatWidget(config));
    } else {
      initializeChatWidget(config);
    }
  },
};

function App() {
  return <div className="App">{/* Main App */}</div>;
}

export default App;
